import styles from "./SkipFilters.module.scss";
import { SecondaryButton as V31SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { SecondaryButton as DeprecatedSecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import classNames from "classnames";
import { useFeatureFlags } from "@/flags/flags";

export function SkipFilters() {
  const { isJldsV31Enabled } = useFeatureFlags();

  return isJldsV31Enabled?.value ? (
    <V31SecondaryButton
      data-testid="skip-filters-link"
      tag="a"
      href="#main-content"
      aria-label="Skip filters and jump to search results"
      className={classNames(styles.visuallyHidden, styles.visibleOnFocus)}
      labelText="Skip Filters"
    />
  ) : (
    <DeprecatedSecondaryButton
      data-testid="skip-filters-link"
      tag="a"
      href="#main-content"
      aria-label="Skip filters and jump to search results"
      className={classNames(styles.visuallyHidden, styles.visibleOnFocus)}
    >
      Skip Filters
    </DeprecatedSecondaryButton>
  );
}
